import React from 'react'
import PropTypes from 'prop-types';
import PriceMatrix from 'pu-react/components/PriceMatrix';
import Notes from './price_plx/Notes'
import PriceMatrixCell from './price_plx/PriceMatrixCell'
import SupplierTypes from '../data/supplierTypes';

const PricePlx = ({
  quote, parametersChanged, onPriceSelect, parameters, quoteStep,
}) => {
  const lineItem = quote.line_items.find((li) => li.quote_config_key === SupplierTypes.PLX_BEST_PRICE);

  if (!lineItem || !lineItem.product_key) {
    return null
  }
  return (
    <div className="card-body price-combined price-plx">
      <div className="">
        <h2 className="price-matrix-title">Standard Specs</h2>
        <Notes />
        <PriceMatrix
          tableSm
          tableStripe={false}
          lineItem={lineItem}
          supplier={lineItem.product_key}
          parametersChanged={parametersChanged}
          matrixCell={PriceMatrixCell}
          onPriceSelect={onPriceSelect}
          parameters={parameters}
          quoteStep={quoteStep} />
      </div>
    </div>
  )
};

PricePlx.propTypes = {
  quote: PropTypes.object.isRequired,
  parametersChanged: PropTypes.bool.isRequired,
  onPriceSelect: PropTypes.func.isRequired,
  parameters: PropTypes.object.isRequired,
  quoteStep: PropTypes.string.isRequired,
}

export default PricePlx
